import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQAccordion() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-6 md:px-12 md:py-7" data-id="element-47" data-mp="26b0cb7n1a9xi">
      <h2 className="text-center text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-blue-950 md:text-[32px]" data-id="element-48" data-mp="21hfepgpcrhyu">
        Frequently asked questions
      </h2>
      <div className="mt-3 divide-y divide-slate-200 overflow-hidden rounded-md border border-slate-200 bg-white" data-id="element-49" data-mp="2abaj2minh4df">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-50" data-mp="2k9qdaycz4tr5" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left md:py-2.5" data-id="element-51" data-mp="2k9gkz44giaia">
                <span className="text-[14px] font-bold leading-tight text-blue-950 md:text-[15px]" data-id="element-52" data-mp="2zrmhk8n7ummd">{f.q}</span>
                <ChevronDownIcon className={`h-4 w-4 shrink-0 text-amber-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} strokeWidth={3} aria-hidden data-id="element-53" data-mp="33sybgqd4hu0d" />
              </button>
              <AnimatePresence initial={false} data-id="element-54" data-mp="3ijxezmz3psd3">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-55" data-mp="3nhyujxxbj9jt">
                    <p className="px-3 pb-2.5 text-[14px] leading-[1.35] text-slate-600 md:text-[15px]" data-id="element-56" data-mp="2255mla1ygl3s">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}